import { mockData } from "./mockData";
import { IMockData } from "./types";

export function getAudioArray(): IMockData[]{
    return mockData

}